import { render, staticRenderFns } from "./AppDateTimeField.vue?vue&type=template&id=53505440&scoped=true"
import script from "./AppDateTimeField.vue?vue&type=script&lang=js"
export * from "./AppDateTimeField.vue?vue&type=script&lang=js"
import style0 from "./AppDateTimeField.vue?vue&type=style&index=0&id=53505440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53505440",
  null
  
)

export default component.exports